import React from 'react'

const Sixty = () => {
    return (
        <div className='container'>
            <h1>C Program for Binary Search using Recurssion</h1>
         <div className='containers'>
         If the input array is {1, 2, 3, 4, 5, 6} <br />
and the key to be searched for is 6 <br />
then the expected output will be "Search Successful". <br /> </div>
         We basically ignore half of the elements just after one comparison.br
         <ol>
             <li>Compare x with the middle element.</li>
             <li>If x matches with middle element, we return the mid index.</li>
             <li>Else If x is greater than the mid element, then x can only lie in right half subarray after the mid element. So we recur for right half.</li>
             <li>Else (x is smaller) recur for the left half.</li>
         </ol>
        <div className='containers'>
       <code className='library'>#include</code> &lt;stdio.h&gt;<br/>

       <code className='comment'>// A recursive binary search function. It returns</code><br/>
       <code className='comment'>// location of x in given array arr[l..r] is present,</code><br/>
       <code className='comment'>// otherwise -1</code><br/>
       <code className='keywords'>int</code> binarySearch(int arr[], int l, int r, int x)<br/>
&#123;<br/>
<code className='keywords'>if </code>(r &gt;= l) &#123;<br/>
<code className='keywords'>int</code> mid = l + (r - l) / 2;<br/>

<code className='comment'>// If the element is present at the middle</code><br/>
<code className='comment'>// itself</code><br/>
<code className='keywords'>if</code> (arr[mid] == x)<br/>
<code className='keywords'>	return</code> mid;<br/>

<code className='comment'>// If element is smaller than mid, then</code><br/>
<code className='comment'>// it can only be present in left subarray</code><br/>
<code className='keywords'>if</code> (arr[mid] &gt; x)<br/>
<code className='library'>	return</code> binarySearch(arr, l, mid - 1, x);<br/>

<code className='comment'>// Else the element can only be present</code><br/>
        <code className='comment'>// in right subarray</code><br/>
        <code className='library'>return</code> binarySearch(arr, mid + 1, r, x);<br/>
        &#125;<br/>

        <code className='comment'>// We reach here when element is not</code><br/>
        <code className='comment'>// present in array</code><br/>
        <code className='library'>return</code> -1;<br/><br/>
&#125;<br/>

<code className='comment'>int</code> main(void)<br/>
&#123;<br/>
<code className='comment'>int</code> arr[] = &#123; 2, 3, 4, 10, 40 &#125;;<br/>
<code className='comment'>int</code> n = sizeof(arr) / sizeof(arr[0]);<br/>
<code className='comment'>int</code> x = 10;<br/>
<code className='comment'>int</code> result = binarySearch(arr, 0, n - 1, x);<br/>
(result == -1) ? <code className='library'>printf</code>("Element is not present in array")<br/>
            : printf("Element is present at index %d",<br/>
                        result);<br/>
                        <code className='library'>return</code> 0;<br/>
&#125;<br/>
        </div>
        </div>
    )
}

export default Sixty
